export default "<p>show-multi-pdf works!</p>\n";